<template>
  <section class="main-section main-section--white foldaz-section">
    <div class="container">
      <nav
        v-if="folder.team"
        class="breadcrumb"
      >
        <ul class="breadcrumb__list">
          <li class="breadcrumb__item">
            <router-link
              :to="{ name: 'Folders', hash: `#team-${folder.team.slug}` }"
              class="breadcrumb__link"
            >{{ folder.team.name }}</router-link>
          </li>
        </ul>
      </nav>
      <div class="text-center add-margin-bottom-full">
        <h2 class="h1 add-margin-bottom">{{ folder.name }}</h2>
        <div class="text-medium text-disabled">
          {{ folder.description }}
        </div>
      </div>

      <content-controls />
      <content-filter-details
        :reset-enabled="true"
        @resetFilter="resetFilter"
      />

      <component
        :is="selectedLayout"
        :entries="contents"
      />

      <div
        v-t="'p.foldersDetailPage.message.empty'"
        v-if="contents.length == 0"
        class="text-center add-padding-top-double"
      />

      <button
        v-show="nextPage"
        :disabled="isLoading"
        class="add-margin-top-double button button--outline button--full button--big"
        @click="loadMore"
      >
        <span>
          <font-awesome-icon
            icon="redo"
            size="sm"
          />
          {{ isLoading ? $t('p.streamPage.label.loadingInProgress') : $t('p.streamPage.label.loadMoreContent') }}
        </span>
      </button>
    </div>

    <button
      v-if="!webviewActive"
      class="add-content-button"
      @click.prevent="openContentModalLinkMode"
    />
    <content-modal />
    <content-copy-modal />
  </section>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

import ContentModal from '@/components/contents/ContentModal'
import ContentCopyModal from '@/components/contents/ContentCopyModal'
import ContentControls from '@/components/contents/ContentControls'
import ContentFilterDetails from '@/components/contents/ContentFilterDetails'
import ContentGridView from '@/components/contents/ContentLayoutGridView'
import ContentListView from '@/components/contents/ContentLayoutListView'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'FoldersPage',
  components: {
    ContentModal,
    ContentCopyModal,
    ContentControls,
    ContentFilterDetails,
    ContentGridView,
    ContentListView,
    FontAwesomeIcon
  },
  data () {
    return {
      initializedAt: new Date()
    }
  },
  computed: {
    ...mapState({
      filter: state => state.contentFilter.filter,
      folder: state => state.folder.folder,
      meta: state => state.contents.meta,
      contents: state => state.contents.contents,
      isLoading: state => state.contents.request.isLoading,
      contentModalIsVisible: state => state.contentModal.isVisible,
      currentPage: state => state.contentFilter.filter.page,
      webviewActive: state => state.webview.active
    }),
    ...mapGetters([
      'isGridLayout'
    ]),
    nextPage () {
      return this.meta && this.meta.nextPage
    },
    selectedLayout () {
      return this.isGridLayout ? 'ContentGridView' : 'ContentListView'
    }
  },
  watch: {
    contentModalIsVisible: {
      immediate: true,
      handler () { this.renderHtmlOverflow() }
    },
    $route: {
      deep: true,
      immediate: true,
      handler ($route) {
        this.initFolder($route.params.folderId)
      }
    }
  },
  methods: {
    ...mapActions({
      openContentModalLinkMode: 'openContentModalLinkMode',
      setPage: 'contentFilter/setPage',
      setInitializedAtUntil: 'contentFilter/setInitializedAtUntil',
      setInitializedAtFrom: 'contentFilter/setInitializedAtFrom',
      resetContentFilter: 'contentFilter/reset',
      fetchContents: 'contents/fetch',
      fetchContentsForFolder: 'contents/fetchForFolder',
      setContents: 'contents/apply',
      appendContents: 'contents/append',
      resetContents: 'contents/reset',
      fetchFolder: 'fetchFolder'
    }),
    initFolder (folderId) {
      this.fetchFolder(folderId)
      this.resetContentFilter()

      this.setPage(1)
      this.setInitializedAtUntil(this.initializedAt)
      this.setInitializedAtFrom('')

      this.fetchContentsForFolder(folderId)
        .then((response) => {
          this.setContents(response)
          this.$emit('loadingDone')
        })
    },
    renderHtmlOverflow () {
      const hasModal = this.contentModalIsVisible
      const htmlEl = document.querySelector('html')
      htmlEl.style.overflow = hasModal ? 'hidden' : ''
    },
    loadMore () {
      // set filter
      this.setPage(this.currentPage + 1)
      this.setInitializedAtUntil(this.initializedAt)
      this.setInitializedAtFrom('')

      // fetch content
      this.fetchContents()
        .then((response) => {
          this.appendContents(response)
        })
    },
    resetFilter () {
      this.resetContentFilter()
      this.fetchContentsForFolder(this.$route.params.folderId)
    }
  },
  beforeDestroy () {
    this.resetContentFilter()
    this.resetContents()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/folders/FoldersDetailPage.vue